import React from 'react';

function NoteItem({ note, onEdit, onDelete }) {
  const handleEdit = () => {
    onEdit(note);
  };

  const handleDelete = () => {
    onDelete(note.id);
  };

  // Format date to be more readable
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <article className="note-item">
      <div className="note-header">
        <h3 className="note-title">{note.title}</h3>
        <div className="note-actions">
          <button
            className="btn-icon btn-edit"
            onClick={handleEdit}
            aria-label="Edit note"
            title="Edit note"
          >
            ✏️
          </button>
          <button
            className="btn-icon btn-delete"
            onClick={handleDelete}
            aria-label="Delete note"
            title="Delete note"
          >
            🗑️
          </button>
        </div>
      </div>

      <div className="note-content">
        <p>{note.content}</p>
      </div>

      <div className="note-footer">
        <span className="note-date" title={note.created_at}>
          Created: {formatDate(note.created_at)}
        </span>
        {note.updated_at && note.updated_at !== note.created_at && (
          <span className="note-date" title={note.updated_at}>
            Updated: {formatDate(note.updated_at)}
          </span>
        )}
      </div>
    </article>
  );
}

export default NoteItem;
